@if (passkeys().length === 0) {
  <div class="text-sm text-base-content/70" data-testid="passkeys-empty">Keine Passkeys eingerichtet.</div>
} @else {
  <table class="bm-table bm-table-sm w-full">
    <thead>
      <tr>
        <th>Name</th>
        <th>Erstellt</th>
        <th>Zuletzt benutzt</th>
        <th>Synchronisiert</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      @for (passkey of passkeys(); track passkey.id) {
        <tr data-testid="passkey-row">
          <td>
            @if (editingId === passkey.id) {
              <form class="bm-join" (submit)="saveRename(passkey)">
                <input
                  type="text"
                  class="bm-input bm-input-sm bm-join-item"
                  name="name"
                  maxlength="100"
                  aria-label="Neuer Name"
                  [(ngModel)]="editName"
                  (keydown.escape)="cancelRename()"
                />
                <button type="submit" class="bm-btn bm-btn-sm bm-btn-primary bm-join-item" title="Speichern">
                  <fa-icon [icon]="faCheck"></fa-icon>
                </button>
                <button type="button" class="bm-btn bm-btn-sm bm-join-item" title="Abbrechen" (click)="cancelRename()">
                  <fa-icon [icon]="faTimes"></fa-icon>
                </button>
              </form>
            } @else {
              {{ passkey.name || "–" }}
            }
          </td>
          <td>{{ passkey.created_at | date: "dd.MM.yyyy HH:mm" }}</td>
          <td>{{ passkey.last_used_at ? (passkey.last_used_at | date: "dd.MM.yyyy HH:mm") : "noch nie" }}</td>
          <td>
            @if (passkey.backed_up) {
              <span class="text-green-600">ja</span>
            } @else {
              <span class="text-base-content/70">nein</span>
            }
          </td>
          <td class="text-right whitespace-nowrap">
            @if (allowRename() && editingId !== passkey.id) {
              <button type="button" class="bm-btn bm-btn-xs bm-btn-ghost" (click)="startRename(passkey)">
                <fa-icon [icon]="faEdit"></fa-icon>
                Umbenennen
              </button>
            }
            <button
              type="button"
              class="bm-btn bm-btn-xs bm-btn-ghost text-error"
              data-testid="passkey-delete"
              (click)="confirmDelete(passkey)"
            >
              <fa-icon [icon]="faTrash"></fa-icon>
              Löschen
            </button>
          </td>
        </tr>
      }
    </tbody>
  </table>
}
